import { DEFAULT_LOCALE } from '@moussenaires/shared';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './locales/en.js';
import { fr } from './locales/fr.js';

const STORAGE_KEY = 'moussenaires.locale';

function readStoredLocale(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? DEFAULT_LOCALE;
  } catch {
    return DEFAULT_LOCALE;
  }
}

void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en } },
  lng: readStoredLocale(),
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function persistLocale(locale: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // ignore
  }
}

export default i18n;
